import * as Styled from './Card.styled';

import type { CardProps } from './Card.typed';

const Card = (props: CardProps) => {
  const {
    header,
    body,
    footer,
    orientationSmall,
    orientationMedium,
    orientationLarge,
    isDisabled,
    className,
    image,
    paddingSmall,
    paddingMedium,
    paddingLarge,
    gapSmall,
    gapMedium,
    gapLarge,
    fillContainer = true,
    trailingImageSmall,
    trailingImageMedium,
    trailingImageLarge,
    backgroundColor = 'WHITE',
    footerAlignment,
  } = props;

  return (
    <Styled.Container
      className={className}
      orientationSmall={orientationSmall}
      orientationMedium={orientationMedium}
      orientationLarge={orientationLarge}
      isDisabled={isDisabled} // TODO: remove
      backgroundColor={backgroundColor}
    >
      <Styled.ImageContainer
        {...{ trailingImageSmall, trailingImageMedium, trailingImageLarge }}
      >
        {image}
      </Styled.ImageContainer>
      <Styled.CardBody
        orientationSmall={orientationSmall}
        orientationMedium={orientationMedium}
        orientationLarge={orientationLarge}
        {...{
          paddingSmall,
          paddingMedium,
          paddingLarge,
          gapSmall,
          gapMedium,
          gapLarge,
          fillContainer,
        }}
      >
        {header}
        {body}
        {footer && (
          <Styled.Footer footerAlignment={footerAlignment}>
            {footer}
          </Styled.Footer>
        )}
      </Styled.CardBody>
    </Styled.Container>
  );
};

export { Card };
